// extracted by mini-css-extract-plugin
export var hidden = "_uu-0";